import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { NavItem } from '@/shared/types/navigation';
import { useTranslation } from 'react-i18next';

interface SortableMenuItemProps {
  item: NavItem;
}

export const SortableMenuItem: React.FC<SortableMenuItemProps> = ({ item }) => {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.name });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`flex items-center gap-3 p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg cursor-move
        ${isDragging ? 'opacity-50 shadow-lg' : ''}
        hover:border-brand-500 dark:hover:border-brand-500 transition-colors duration-200`}
      data-testid={`menu-item-${item.name}`}
    >
      <div className="text-gray-400 dark:text-gray-500" data-testid={`menu-item-drag-handle-${item.name}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 9h14M5 15h14" />
        </svg>
      </div>
      <div className="flex items-center gap-3 flex-1">
        <span className="text-gray-500 dark:text-gray-400" data-testid={`menu-item-icon-${item.name}`}>
          {item.icon}
        </span>
        <span className="text-gray-900 dark:text-white font-medium" data-testid={`menu-item-text-${item.name}`}>
          {t(item.name)}
        </span>
      </div>
    </div>
  );
};
